import {takeLatest} from 'redux-saga';
import {push} from 'react-router-redux';
import {call, put, select} from 'redux-saga/effects';

import {
  loginMeta,
  loginSucceeded,
  loginFailed,
  logoutFailed,
  logoutSucceeded
} from 'actions/index';

import {fetchSession} from 'actions/api';
import {getSession, login, logout} from 'api/index';

const entryPathSelector = state => state.login.entryPath;
const sessionSelector = state => state.login.session;

const DEFAULT_PATH = '/admin/candidates';
const LOGIN_PATH = '/login';

import {LOGIN_SUCCEEDED, LOGOUT_REQUESTED, GET_SESSION} from '../constants';

export default function() {
  return [
    takeLatest(GET_SESSION, function*(action) {
      const {payload: {entryPath}} = action;

      if (entryPath !== LOGIN_PATH) {
        //save entry path if its not the login path
        yield put(loginMeta(entryPath));
      }

      const session = yield select(sessionSelector);
      if (session) {
        //already in active session, go to default path if at login path
        if (entryPath === LOGIN_PATH) {
          yield put(push(DEFAULT_PATH));
        }
      } else {
        //request session
        const fetch = yield put(fetchSession());
        const res = yield fetch;
        if (res.type === 'SUCCESS') {
          //session retrieved from server
          yield put(loginSucceeded());
          if (entryPath === LOGIN_PATH) {
            yield put(push(DEFAULT_PATH));
          }
        } else if (res.type === 'FAILURE') {
          //sesson invalid, go to login path, if not already there
          if (entryPath !== LOGIN_PATH) {
            yield put(push(LOGIN_PATH));
          }
        }
      }
    }),

    takeLatest(LOGIN_SUCCEEDED, function*(action) {
      const {payload} = action;

      //redirect to entry path or default path
      const path = yield select(entryPathSelector);
      yield put(push(path && path !== LOGIN_PATH ? path : DEFAULT_PATH));

    }),

    takeLatest(LOGOUT_REQUESTED, function*(action) {
      const {payload} = action;

      try {
        yield call(logout);
        yield put(logoutSucceeded());
        yield put(push(LOGIN_PATH));
      } catch (ex) {
        const {response: {data: {message}}} = ex;
        yield put(logoutFailed(message));
      }
    })
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/login.js